import { useRef, useState } from "react";
import { Music } from "lucide-react";
import { toast } from "sonner";

const AUDIO_SOURCES = [
  {
    src: "https://upload.wikimedia.org/wikipedia/commons/c/cb/A_Midsummer_Night%27s_Dream_Op._61_Wedding_March_%28Mendelssohn%29_European_Archive.ogg",
    type: "audio/ogg",
  },
  {
    src: "https://upload.wikimedia.org/wikipedia/commons/c/ce/Sousa%27s_%22Wedding_March%22_-_United_States_Marine_Band_%282019%29.mp3",
    type: "audio/mpeg",
  },
  {
    src: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3",
    type: "audio/mpeg",
  },
];

export default function VinylPlayer() {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const toggle = async () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (playing) {
      audio.pause();
      setPlaying(false);
      return;
    }
    try {
      await audio.play();
      setPlaying(true);
    } catch {
      toast.error("მუსიკის დაკვრა ვერ მოხერხდა, სცადეთ თავიდან");
    }
  };

  return (
    <section data-testid="vinyl-player-container" className="space-y-5 text-center">
      <p className="eyebrow !text-[#B45309]">დააჭირე</p>

      <div className="turntable">
        <button
          data-testid="vinyl-player-toggle-button"
          onClick={toggle}
          className="mx-auto block rounded-full transition-transform hover:scale-[1.03] active:scale-95"
          aria-label={playing ? "მუსიკის შეჩერება" : "მუსიკის დაკვრა"}
        >
          <div
            data-testid="vinyl-spinning-disc"
            className={`vinyl-disc ${playing ? "spinning" : ""}`}
          >
            <div className="vinyl-label">
              <Music size={18} />
            </div>
          </div>
        </button>

        <div
          data-testid="vinyl-turntable-tonearm"
          className={`tonearm ${playing ? "playing" : ""}`}
          aria-hidden="true"
        >
          <span className="pivot" />
          <span className="arm" />
          <span className="head" />
        </div>
      </div>

      <div className="flex items-center justify-center gap-3">
        <div className={`eq ${playing ? "playing" : ""}`} aria-hidden="true">
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>
        <p data-testid="vinyl-music-status-label" className="text-xs tracking-[0.18em] text-[#78716C]">
          {playing ? "მენდელსონი — საქორწინო მარში" : "საქორწინო მელოდია"}
        </p>
      </div>

      <audio ref={audioRef} loop preload="none">
        {AUDIO_SOURCES.map((s) => (
          <source key={s.src} src={s.src} type={s.type} />
        ))}
      </audio>
    </section>
  );
}
